<template>
    
    <div class="w-full h-auto flex flex-col" > 

        <label class="text-xs block tracking-widest py-2" v-if="label" >{{ label + ( required ? '*' : '' ) }}</label>

        <input 
        
        class=" text-sm 
                w-full 
                h-12 
                border 
                border-solid 
                border-gray-400
                rounded-md 
                px-4 
                outline-none
                focus:border-ch-blue"

        :type="type"
        :placeholder="placeholder"

        @keyup="checkTyping"

        v-model="input"
        
        >

        <transition name="error" >

            <p v-if="errorMessage" class="h-auto py-2 ml-6 text-xs text-ch-red error relative tracking-widest" >{{ errorMessage }}</p>

        </transition>

    </div>

</template>

<script>

    import { ref, watch, onMounted, computed } from 'vue'

    import { debounce } from '../assets/scripts/debounce'
    import { validateInput } from '../assets/scripts/inputValidation'

    export default {
    
        name: 'Input',

        props: {

            label: String,
            disabled: Boolean,
            modelValue: String,
            placeholder: String,
            min: { type: Number, default: null },
            max: { type: Number, default: null },
            regex: { type: String, default: null },
            type: { type: String, default: 'text' },
            validate: { type: Boolean, default: true },
            required: { type: Boolean, default: true },

        },
        
        setup( props, { emit } ) {

            const valid = ref(false)
            const hadInput = ref(false)
            const errorMessage = ref('')

            const input = computed({
                get: () => props.modelValue,
                set: val => emit( 'update:modelValue', val )
            })

            const validation = () => {

                if ( props.validate && input.value ) {

                    const { isValid, error } = validateInput( 
                        props.type, 
                        input.value, 
                        props.label || 'This field',
                        {
                            min: props.min,
                            max: props.max,
                            regex: props.regex
                        }
                    )
                    
                    valid.value = isValid
                    errorMessage.value = error

                }

            }

            const checkRequired = () => {

                if ( props.required && hadInput.value ) {

                    if ( !input.value ) {

                        valid.value = false
                        errorMessage.value = `${props.label} is required.`

                    }

                    else validation()

                }

                else validation()

            }

            const checkTyping = debounce(function() { checkRequired() }, 1000)

            watch(input, () => {

                errorMessage.value = '',
                valid.value = false

                if ( input.value ) hadInput.value = true

            })

            watch(valid, () => { emit( 'valid', valid.value ) })

            onMounted(checkRequired)
            
            return {
                input,
                valid,
                checkTyping,
                errorMessage
            }

        }

    }

</script>
